import React from 'react';
import CustomHint from '../../assets/containers/CustomHint';
import AnimatedPageContainer from '../../assets/containers/AnimatedPageContainer';
import { useParams } from 'react-router';

const CreatedTicket = () => {
    const { id } = useParams();
    const validId = typeof id === 'string' && /^[a-f0-9]{24}$/i.test(id);
    return (
        <AnimatedPageContainer>
            <div className='customContainer'>
                <CustomHint>
                    {validId ? (
                        <>
                            تیکت شما با موفقیت ثبت شد.
                            <br />
                            کد رهگیری : <span dir="ltr">{id}</span>
                        </>
                    ) : 'کد پیگیری نامعتبر است.'}
                </CustomHint>
            </div>
        </AnimatedPageContainer>
    )
}

export default CreatedTicket
